<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="route_non_gt"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="routeNonGTForm"
          :redirect-detail="true"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Customer Rute Non GT Listing"
          addButton="Tambah Rute Konsumen Non GT"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>
      </b-col>

      <b-modal
        ref="myModalRef"
        id="addModals"
        header-border-variant="no-border text-center"
        footer-border-variant="no-border"
        footer-bg-variant="light"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        size="lg"
      >
        <div slot="modal-header" class="text-center">
          <h3 class="text-center">Input Rute Non GT Baru</h3>
        </div>

        <b-form id="assetOwnerForm" validated novalidate>
          <b-row>
            <b-col sm="3">
              <b-form-group label-for="route_id" label="Rute">
                <model-select
                  id="route_id"
                  :options="listRoute"
                  v-model="$v.routeNonGTForm.route_id.$model"
                  :isError="$v.routeNonGTForm.route_id.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="routeNonGTForm.route_id === null"
                  class="invalid-feedback-custom"
                >Rute harus di pilih.</div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>

        <div slot="modal-footer" class="float-right">
          <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
            <i class="fa fa-undo"></i> Back
          </b-button>&nbsp;
          <b-button
            type="button"
            size="sm"
            variant="primary"
            @click="saveProcess"
            :disabled="$v.routeNonGTForm.$invalid"
          >
            <i class="fa fa-save"></i> Save
          </b-button>
        </div>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";

export default {
  name: "route_non_gt",
  components: { globalTable, ModelSelect },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      route_non_gt: [],
      listRoute: [],
      loading: true,
      fields: [
        { key: "name", label: "Nama Rute", sortable: true },
        { key: "total", label: "Total Konsumen", sortable: true },
        { key: "action", class: "text-center width-80" }
      ],
      routeNonGTForm: interfaces.route_non_gt
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    routeNonGTForm: {
      route_id: { required }
    }
  },
  methods: {
    init: function() {
      this.getRouteNonGT();
      this.getDropdown();
    },
    getRouteNonGT: function() {
      this.axios
        .get("web/customer/route-non-gt/")
        .then(response => {
          this.route_non_gt = response.data.data;
        })
        .catch(error => {
          this.expired(error, "Rute Non GT");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/route-non-gt/")
        .then(response => {
          this.listRoute = response.data.route;
        })
        .catch(error => {
          this.expired(error, "Rute Dropdown Non GT");
        })
        .finally(() => {});
    },
    resetForm: function() {
      for (var a in interfaces.route_non_gt) {
        interfaces.route_non_gt[a] = null;
      }
      this.routeNonGTForm = interfaces.route_non_gt;
    },
    editForm: function() {},
    cancelAdd: function() {
      this.resetForm();
      this.$refs.myModalRef.hide();
    },
    saveProcess: function(evt) {
      if (confirm("Apakah anda ingin menambahkan Rute ini ?")) {
        this.axios
          .post("web/customer/add-customer-route-non-gt/", this.routeNonGTForm)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah Rute Berhasil",
                message: response.data.message
              });
              this.$router.push({ path: "all/detail/" + response.data.id });
            } else {
              this.showErrorNotification({
                title: "Tambah Rute Gagal",
                message: response.data.message
              });
            }
          })
          .catch(error => {
            this.expired(error, "Tambah Rute");
          })
          .finally(() => {
            this.cancelAdd();
            this.init();
          });
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>